import { combineReducers } from 'redux';

import { uploadAvatar, deleteAvatar, getUserTripsStats } from '@ott/shared-solar-logic';
import authReducer from '@ott/solar-auth';
import { limiter } from '@ott/superagent';

import ssr from './ssr';

export default combineReducers({
  uploadAvatar,
  deleteAvatar,
  tripsStats: getUserTripsStats,
  auth: authReducer,
  ssr,
  limiter: limiter.reducer,
});
